var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhaseIconL2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.56 184.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#34495e;}.cls-2,.cls-3{fill:#fff;}.cls-3{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 184.56,
    height: 184.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,114.51H89.6v11.34H49.21V64.71H64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.6,125.85H95.94v-9.24L115.59,96q7.26-8.26,7.26-13.14a9.16,9.16,0,0,0-1.72-6,6.15,6.15,0,0,0-5-2,6.22,6.22,0,0,0-5.25,2.75,11.31,11.31,0,0,0-2,6.86H94.68A20,20,0,0,1,97.49,74a19.66,19.66,0,0,1,7.81-7.45,23.09,23.09,0,0,1,11.17-2.69q9.91,0,15.26,4.58t5.36,13.14a19,19,0,0,1-1.35,7,30.49,30.49,0,0,1-4.17,7.18,105,105,0,0,1-9.14,10.06l-7.89,9.11H138.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.87,33.37h0a5,5,0,0,1-5-5V0h9.94l0,28.4A5,5,0,0,1,131.87,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.37,33.37h0a5,5,0,0,1-5-5V0h9.93v28.4A5,5,0,0,1,150.37,33.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M168.87,33.37h0a5,5,0,0,1-5-5V0h9.93v28.4A5,5,0,0,1,168.87,33.37Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIconL2);
export default __webpack_public_path__ + "static/media/PhaseIconL2.de280b45ea0912be734abafc0ca40fcf.svg";
export { ForwardRef as ReactComponent };